import {createSlice} from '@reduxjs/toolkit';

export const APP_STORE_NAME = 'user';

const initialState = {
  tgUser: null,
};

const userSlice = createSlice({
  name: APP_STORE_NAME,
  initialState,
  reducers: {
    setTgUser(state, {payload}) {
      state.tgUser = payload;
      //{
      //  id,
      //  first_name
      //  last_name
      //  username
      //  language_code
      //  allows_write_to_pm
      //}
    },
  },
});

export const {actions, reducer} = userSlice;
